'use client'

import Lottie from 'lottie-react'
import { useTheme } from 'next-themes'

interface ThemedLottieProps {
  name: string
  loop?: boolean
  autoplay?: boolean
  className?: string
}

export const ThemedLottie = ({
  name,
  loop = false,
  autoplay = true,
  className,
}: ThemedLottieProps) => {
  const { resolvedTheme } = useTheme()
  const animationName = resolvedTheme === 'dark' ? `${name}-dark` : name

  return (
    <Lottie
      animationData={require(`@/app/component-library/Icons/Lottie/${animationName}.json`)}
      loop={loop}
      autoplay={autoplay}
      className={className}
    />
  )
}
